import * as React from "react";

import { Wrapper, CodeWrapper, Title, HelpLink } from "./app-qr-code-style";
import { getDocURL } from "common/docUrl";
import { lazilyLoadedComponent } from "lib/react-lazy-loading";
import { getLocalizedString } from "common/components/localization";
import { ErrorBoundary } from "lib/error-boundary";

const QRCode = lazilyLoadedComponent("qrcode.react", () => import("qrcode.react"));

interface Props {
    size: number;
    url?: string;
    hideDocumentationLink?: boolean;
}

class AppQRCode extends React.Component<Props, {}> {
    public render() {
        const { size, url, hideDocumentationLink } = this.props;
        const previewText = getLocalizedString("scanCodePreview");
        const [previewTextBeforeLink, previewTextRest] = previewText.split("<a>");
        const [previewLinkText, previewTextAfterLink] = previewTextRest.split("</a>");
        return (
            <Wrapper width={size}>
                <CodeWrapper>
                    <ErrorBoundary>
                        <React.Suspense fallback={<div />}>
                            <QRCode
                                style={{ imageRendering: "pixelated" }}
                                size={size - 42}
                                value={url}
                                fgColor="#313139"
                                bgColor="#ffffff"
                            />
                        </React.Suspense>
                    </ErrorBoundary>
                </CodeWrapper>
                <Title>
                    {previewTextBeforeLink}
                    {hideDocumentationLink !== true && (
                        <>
                            {" "}
                            <HelpLink href={getDocURL("scanInstall")} target="_blank" rel="noopener noreferrer">
                                {previewLinkText}
                            </HelpLink>
                        </>
                    )}
                    {previewTextAfterLink}
                </Title>
            </Wrapper>
        );
    }
}

export default AppQRCode;
